import {
  SPI,
  ActionWidget,
  ActionWidgetProps,
  ActiveRecords,
  FunctionService,
  RequestModelField,
  RuntimeFunctionDefinition,
  RuntimeServerAction,
  ServerActionWidget,
  StaticMetadata,
  FormO2MFieldWidget,
  Optional,
  RuntimeM2MField,
  RuntimeO2MField,
  SubmitCacheManager,
  Widget,
  WidgetTrigger,
  isRelation2MField
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  ActionWidget.Token({
    name: ['uiServerae98fa1697564d19b688879ef54c06d3']
  })
)
export class DeleteAllTableData extends ServerActionWidget {
  initialize(props: ActionWidgetProps<RuntimeServerAction>): this {
    super.initialize(props);
    return this;
  }

  protected executeFunction<T>(
    functionDefinition: RuntimeFunctionDefinition,
    requestFields: RequestModelField[],
    activeRecords: ActiveRecords | undefined
  ): Promise<T> {
    const field = Optional.ofNullable(this.metadataRuntimeContext.field)
      .filter<RuntimeO2MField | RuntimeM2MField | undefined>((v) => isRelation2MField(v!))
      .orElse(undefined);
    const subviewFieldWidget = Optional.ofNullable(this.metadataRuntimeContext.handle)
      .map(Widget.select)
      .map<FormO2MFieldWidget | undefined>((v) => v!.getParent() as unknown as FormO2MFieldWidget)
      .orElse(undefined);

    if (!field || !subviewFieldWidget) {
      console.error('Invalid field and subview widget');
      return new Promise((resolve) => resolve(null as any));
    }

    const showRecords = subviewFieldWidget.dataSource;
    const { submitCache } = field;
    const subviewSubmitCache = this.metadataRuntimeContext.extendData.subviewSubmitCache as SubmitCacheManager;

    if (showRecords) {
      subviewFieldWidget.setValue([]);

      if (submitCache) {
        submitCache.submit([]);
      } else if (subviewSubmitCache) {
        subviewSubmitCache.submit([]);
      }

      // subviewFieldWidget.flushDataSource();
      subviewFieldWidget.afterTriggerExecute?.(WidgetTrigger.CHANGE);
    }
    return new Promise((resolve) => resolve(null as any));
  }
}
